export const service_modes = [
  { code: 'counter', label: 'service_modes.counter' },
  { code: 'table', label: 'service_modes.table' },
  { code: 'hybrid', label: 'service_modes.hybrid'},
];
